// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1zYKi","title":"InfoRow_title__1yV9M"};